import { Add, DocumentDownload, Share } from "@carbon/icons-react";
import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import UIkit from "uikit";
import Constants from "../../../../utils/Constants";
import swal from 'sweetalert';
import { DecryptData } from "../../../../utils/Cipher";
import Swal from 'sweetalert2';
import { usePermissions } from "../../../../context/PermissionsContext";


const Documents = ({data, id , status}) => {

    const [loader, setLoader] = useState(false);
    const [spinner, setspinner] = useState(false);
    const [imgsrc, setimgsrc] = useState('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKoFaBZH2MsbB4t5NO92hFKCbWOJI&usqp=CAU');

    const {Permissions} = usePermissions();
    const user = DecryptData();

    const documents = ["invoice", "gate_pass", "sales_certificate", "vehicle_delivery_acceptance_note"];
    const [docxdata, setdocxdata] = useState(data);

    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm();

    const openModal = () => {
      UIkit.modal("#document").show();
    };

    const openImageModal = (imageUrl) => {
        setimgsrc(imageUrl);
        openImage();
      };

    const openImage  = () => {
        UIkit.modal("#document_image").show();
      };

    const Submit = (data) => {
      setLoader(true);
        
      const formData = new FormData();
      formData.append('orderId', id);
      formData.append('documentType', data.documentType);

      const fileInput = document.getElementById('form-username');
      if (fileInput.files.length > 0) {
        formData.append('image', fileInput.files[0]);
      }
    
  
      axios({
        method: "post",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: formData,
        url: Constants.url + `orders/${id}/add-document`,
      })
        .then((res) => {
          setLoader(false);
          
          if(res.data.status === 'success' ){
            // console.log(res.data.data , "asdasdasdasasd")
            // var newdata = res.data.data.comment
            // setdocxdata([...docxdata, newdata])
            
            window.swal({
              icon:'success',
              title:'success' 
            }).then(() => UIkit.modal("#document").hide() )
          }
        })
        .catch((err) => {
        });
    };

    const downloadFile = async (url, fileName) => {
        try {


            setspinner(true);

            // Fetch the file as a blob using axios
            const response = await axios.get(url, {
              responseType: 'blob', 
              // Important to handle binary data
            });
        
            const fileType = response.headers['content-type'];
            
            const blob = new Blob([response.data], { type: fileType });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            
            const extension = fileType.split("/")[1]; 
            // Extract extension from MIME type (e.g., "png", "pdf")
            const fullFileName = fileName.includes(".") ? fileName : `${fileName}.${extension}`;
            
            link.setAttribute('download', fullFileName);
        
            document.body.appendChild(link);
            link.click();
        
            link.parentNode.removeChild(link);
          } catch (error) {
            console.error("File download failed:", error);
          }
          finally {
            setspinner(false);
          }
      };

    const handleShareDocument = async (docId) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to share this document on your profile?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#32d296',
                cancelButtonColor: '#f0506e',
                confirmButtonText: 'Yes, share it!'
            });

            if (result.isConfirmed) {
                setspinner(true);
                const response = await axios.post(`${Constants.url}orders/${docId}/update-document`, {
                    documentId: docId ,
                    isActive: true
                },
                {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  }
                );

                if (response.data.status === "success") {
                    Swal.fire(
                        'Shared!',
                        'Document has been shared on your profile.',
                        'success'
                    );
                    // Update the local state to reflect the change
                    setdocxdata(prevData => 
                        prevData.map(doc => 
                            doc._id === docId ? {...doc, isActive: false} : doc
                        )
                    );

                    
                } else {
                    throw new Error(response.data.message || 'Failed to share document');
                }
            }
        } catch (error) {
            Swal.fire(
                'Error!',
                error.message || 'Something went wrong while sharing the document.',
                'error'
            );
        } finally {
            setspinner(false);
        }
    };

  return (
    <>
    {/* Modal */}

    <div
      id="document"
      container="#pageId"
      uk-modal=""
      style={{ paddingTop: "180px" }}
    >
      <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large ">
        <button className="uk-modal-close-default" type="button" uk-close>
          X
        </button>

        <h3 className="uk-text-bold uk-text-light">Add Document</h3>

        <form
            className="uk-form-stacked uk-padding "
            onSubmit={handleSubmit(Submit)} >

            <div className="uk-margin-small">
              <label className="uk-form-label" htmlFor="form-username">
                Document Type
              </label>

              <select
                {...register("documentType", { required: "Field is required" })}
              >
                <option value="">Select Document Type</option>{" "}
                {/* Add a default option */}
                <option value="pay-order">Pay Order</option>
                <option value="online-payment">Online Payment</option>
                <option value="delivery-picture">Delivery-Picture</option>
                <option value="cnic_back">CNIC Back</option>
                <option value="cnic_frontend">CNIC Front</option>
                <option value="invoice">Invoice</option>
                <option value="gate_pass">Gate Pass </option>
                <option value="sales_certificate">Sales Certificate</option>
                <option value="vehicle_delivery_acceptance_note">Vehicle Delivery Acceptance Note</option>
              </select>
            </div>
            <div className="uk-margin">
            <label className="uk-form-label" htmlFor="form-username">Upload</label>
            <div className="uk-form-controls">


                <input style={{padding:'5px'}} className="uk-input uk-padding-xsmall uk-form-medium" id="form-username" type="file" placeholder="@peduarte" 
                {...register("image", { required: "Field is required" })}/>


            </div>
          </div>

            <div className="uk-margin uk-flex uk-flex-center">
            <button
                className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
                type="submit"
            >
                {loader ? <div uk-spinner="" className="loader"></div> : "Add"}
            </button>
            </div>
          </form>
      </div>
    </div>

    <div
      id="document_image"
      container="#pageId"
      uk-modal=""
      style={{ paddingTop: "180px" }}
    >
      <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large uk-text-center ">
        <button className="uk-modal-close-default" type="button" uk-close>
          X
        </button>

        <h3 className="uk-text-bold uk-text-light">View Document</h3>

        <img src={imgsrc? imgsrc : '' }  />
      </div>
    </div>
    {/* -------------- */}

    <div className="uk-grid" uk-grid="">
      <div className="uk-width-1-1">
        <div className="analyticsTableWrp ">


          {Permissions?.includes("oms-add-document") && (
            status === 'delivered' || status === 'cancelled' || status === 'incart' || user.role === 'viewer' ? '' :
                <div className="right">
                  <button
                    onClick={openModal}
                    className="uk-button uk-button-secondary"
                  >
                    Add <Add size={24} />
                  </button>
                </div>
              
              )}

          <table className="uk-table  uk-table-hover">
            <thead className="dropdownsum">
              <tr>
                <th className='uk-table-shrink'>S.No</th>
                <th>Document Type</th>
                <th>Document</th>
                <th>Date</th>
                <th>Active Status</th>
              </tr>
            </thead>
            <tbody>
              {docxdata.length > 0 ? (
                docxdata.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.documentType || "-"}</td>
                    <td>
                        {/* <a href={Constants.url+"image"+row.documentUrl|| "#"} download={ "document"}>
                            <DocumentDownload size={24}/> Download 
                        </a> */}
                            <button    onClick={() => downloadFile(Constants.url+"image"+row.documentUrl, "Document" || "document")} style={{ border: 'none', background: 'none', cursor: 'pointer' }}> <DocumentDownload size={24} /> Download </button>
                    </td>
                      <td>
                        {" "}
                        {row.createdAt
                          ? new Date(row.createdAt).toLocaleString("en-US", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            // second: "2-digit", // optional, if you need seconds
                            hour12: true,      // for 12-hour format
                            timeZone: "Asia/Karachi",
                          })
                          : "-"}
                      </td>


                      <td>{(!row?.isActive && documents.includes(row?.documentType)) ?
                       <button 
                           className="uk-button uk-button-small uk-button-default" 
                           style={{
                               backgroundColor: '#32d296',
                               color: 'white',
                               borderRadius: '4px',
                               padding: '2px 15px',
                               cursor: 'pointer'
                           }}
                           onClick={() => handleShareDocument(row._id)}
                           disabled={spinner}
                       >
                           {spinner ? 'Sharing...' : 'Share on Profile  '}
                        <Share/>
                       </button> 
                       :
                       <>
                       { documents.includes(row?.documentType) ? 
                        <>
                    <span className='uk-label uk-label-success'>Shared</span>
                    </> : '-'
                       }
                       </>
                       }</td>




                    {/* {setimgsrc(Constants.url+"photo"+row.documentUrl)} */}
                    {/* <a href={Constants.url+"image"+row.documentUrl || "#"} style={{color: "black"}} target="_blank" rel="noopener noreferrer"> 
                    
                    </a> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="uk-text-center" colSpan={2}>
                    {" "}
                    Record Not Found{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
  )
}

export default Documents